import Escudo from '../icons/escudo.svg';
import Tec from '../icons/tec.svg';
import Reconhecimento from '../icons/reconhecimento.svg';
import Telefone from '../icons/telefone.svg';


const cards = [
  { icon: Telefone, title: "Atendimento personalizado", description: "Nossos especialistas em design e desenvolvimento web criam soluções sob medida para atender às necessidades únicas de cada cliente." },
  { icon: Tec, title: "Website", description: "Seu site é uma extensão da sua empresa, e podemos ajudá-lo a expressá-la adequadamente. Ele é o seu principal ativo de marketing, pois vivemos em uma era digital." },
  { icon: Reconhecimento, title: "Reconhecimento facial", description: "Nosso sistema de reconhecimento facial oferece uma solução eficaz para aumentar a segurança da sua empresa, protegendo seus funcionários e ativos de forma confiável e eficiente." },
  { icon: Escudo, title: "Segurança", description: "Segurança é um pilar importante e fundamental para o nosso desenvolvimento, estamos sempre alinhados para garantir toda a segurança dos nosso clientes. " },
];

export default cards;
